import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type ICardActionsProps = HTMLAttributes<HTMLDivElement>;

export function CardActions({
  children,
  className,
  ...rest
}: PropsWithChildren<ICardActionsProps>) {
  return (
    <div className={twMerge('', className)} {...rest}>
      {children}
    </div>
  );
}
